import { Component, Vue, Prop } from 'vue-property-decorator';

import template from './create-company-subscription.vue';

@Component({
  mixins: [template],
})
export default class CreateCompanySubscription extends Vue {
  @Prop() subscription: { type: number } | undefined;

  otherPage(page: number): void {
    this.$emit(page === 1 ? 'sendForm' : 'last');
  }
}